'use es6';

import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const StyledBlob = styled.div.withConfig({
  displayName: "StyledBlob",
  componentId: "sc-11ba5dw-0"
})(["background-color:", ";height:458px;z-index:-1;border-bottom-left-radius:100%;border-bottom-right-radius:100%;"], GYPSUM);
export default StyledBlob;